import createSvgIcon from '../Utils/CreateSvgIcon';

export const ShoppingBag = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M5.15363 19L5.85733 9.5L18.1427 9.5L18.8464 19L5.15363 19ZM16.9753 7.5L20 7.5L20.8519 19L21 21L18.9945 21L5.00548 21L3 21L3.14815 19L4 7.5L7.02469 7.5C7.27555 4.97334 9.40733 3 12 3C14.5927 3 16.7245 4.97334 16.9753 7.5ZM14.9585 7.5C14.7205 6.08114 13.4865 5 12 5C10.5135 5 9.27952 6.08114 9.04148 7.5L14.9585 7.5Z"
    fillRule="evenodd"
  />,
  'ShoppingBag',
);
